<template>
  <button @click="$emit('click')" :disabled="disabled">
    <div v-if="showSpinner"  class="lds-dual-ring"></div>
    {{ $t('addToCart') }}
  </button>
</template>

<script>
export default {
  name: 'CheckoutButton',
  props: {
    showSpinner: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },
}
</script>

<style scoped>
.lds-dual-ring {
  display: inline-block;
  width: 1em;
  height: 1em;
  margin-right: 1em;
}
.lds-dual-ring:after {
  content: ' ';
  display: block;
  width: 1em;
  height: 1em;
  margin: 0rem;
  border-radius: 50%;
  border: 3px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
